import envDefault from './../util/envDefault';

const sdgHost = envDefault('sdg.host', '');
const sdgContextPath = envDefault('sdg.context', '/sdg-online');

const sdgPath = (path) => {
  return sdgHost + sdgContextPath + path;
};

export const SEARCH_PATH = sdgPath('/document/react/search');
export const PUBLIC_SEARCH_PATH = sdgPath('/public/document/react/search');

export const CATEGORY_TOGGLE_PATH = sdgPath('/docCategory/toggleSubscription/');
export const CATEGORY_CURRENT_SUBSCRIPTIONS = sdgPath('/docCategory/currentSubscriptions');

export const INTERNAL_DOCUMENT_VIEW_PATH = sdgPath('/document/view/');
export const PUBLIC_DOCUMENT_DOWNLOAD_PATH = sdgPath('/public/document/download/');

export const USER_AUTHENTICATED_PATH = sdgPath('/user/auth');

export const INTERNAL_DOCUMENT_SEARCH_PATH = sdgContextPath + '/document/search';
export const PUBLIC_DOCUMENT_SEARCH_PATH = sdgContextPath + '/public/document/search';

export const OPEN_AMENDMENTS_REACT_PATH = sdgPath('/amendment/react/search/sdg_open_amendments');
export const INTERNAL_AMENDMENT_VIEW_PATH = sdgPath('/amendment/internal/view/');
export const OPEN_AMENDMENTS_PATH = sdgContextPath + '/amendment/openRequests';
